import React from 'react'
import clsx from 'clsx'

import WifiOffIcon from 'assets/icons/wifi-off.svg'

export const OfflineNotice = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={clsx('flex flex-col items-center justify-center', className)}
      {...props}
    >
      <div className="flex justify-center mb-4">
        <div className="bg-gray-300 rounded-full h-14 w-14 flex items-center justify-center">
          <WifiOffIcon
            width={24}
            height={24}
            className="stroke-current text-gray-700"
          />
        </div>
      </div>
      <h1 className="font-semibold mb-2 text-center">
        Tidak Ada Koneksi Internet
      </h1>
      <p className="text-center">
        Pastikan koneksi internet Anda aktif untuk memuat halaman ini.
      </p>
    </div>
  )
}
